import { MinusCircleOutlined } from "@ant-design/icons";
import { useUser } from "@p0security/frontend-core";
import { FirestoreDoc } from "@p0security/frontend-core/react";
import { PermissionRequest } from "@p0security/shared/types/permission";
import { Button, Flex, Typography } from "@p0security/ui";
import { GraphTooltip } from "components/GraphTooltip";
import { format, formatDistance } from "date-fns";
import { useMemo } from "react";

import { isGrantHolder } from "../requestUtils.ts";

export const ActiveRequestActions: React.FC<{
  onRevoke: () => void;
  processing?: boolean;
  request: FirestoreDoc<PermissionRequest>;
}> = (props) => {
  const { onRevoke, processing, request } = props;
  const { user } = useUser();
  const Info = request.data.expiryTimestamp ? (
    <GraphTooltip
      key="expiry"
      title={format(request.data.expiryTimestamp, "PPpp")}
    >
      <Typography.Text type="secondary">
        Expires in {formatDistance(request.data.expiryTimestamp, Date.now())}
      </Typography.Text>
    </GraphTooltip>
  ) : null;

  const label = useMemo(
    () => (isGrantHolder(user, request.data) ? "Relinquish" : "Revoke"),
    [request.data, user]
  );

  const RevokeButton = (
    <GraphTooltip
      key="revoke"
      title={
        request.data.status !== "DONE_NOTIFIED" ? (
          "Request is currently being processed and cannot be revoked."
        ) : (
          <>{label} grant from user</>
        )
      }
    >
      <Button
        key="revoke"
        type="default"
        onClick={onRevoke}
        loading={processing}
        disabled={request.data.status !== "DONE_NOTIFIED"}
      >
        <MinusCircleOutlined /> {label}
      </Button>
    </GraphTooltip>
  );
  return (
    <Flex className="items-center gap-2">
      {Info}
      {RevokeButton}
    </Flex>
  );
};
